import { render } from "./Infos_API.vue?vue&type=template&id=fd8b2390"
const script = {}

import "./Infos_API.vue?vue&type=style&index=0&id=fd8b2390&lang=css"
script.render = render

export default script